import { render, staticRenderFns } from "./CustomerDetailNamu.vue?vue&type=template&id=0466c396&scoped=true"
import script from "./CustomerDetailNamu.vue?vue&type=script&lang=js"
export * from "./CustomerDetailNamu.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailNamu.vue?vue&type=style&index=0&id=0466c396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466c396",
  null
  
)

export default component.exports